// src/services/profileApi.js
import http from '@/lib/http';

// Helper: unwrap API responses to a plain profile object
function normalizeProfileResponse(data) {
  // backend may return { ok: true, profile: {...} } or just {...}
  if (data && typeof data === 'object') {
    if ('profile' in data && data.profile && typeof data.profile === 'object') {
      return data.profile;
    }
    // fallback to data if it already looks like a profile row
    return data;
  }
  return {};
}

export async function apiGetMyProfile() {
  const { data } = await http.get('/profile/me');
  return normalizeProfileResponse(data);
}

export async function apiGetProfileById(id) {
  const { data } = await http.get(`/profiles/${encodeURIComponent(id)}`);
  return normalizeProfileResponse(data);
}

export async function apiUpsertMyProfile(payload) {
  // backend alias to PUT/POST; using POST as per your note
  const { data } = await http.post('/profile', payload);
  return normalizeProfileResponse(data);
}
